import { SET_CALENDAR_STATUS, SET_CALENDAR_EVENTS, SET_CALENDAR_LOADING } from '../constants';

interface CalendarState {
  status: Record<string, any>;
  events: Record<string, any[]>;
  loading: boolean;
}

const initialState: CalendarState = {
  status: {},
  events: {},
  loading: false,
};

export default function calendarReducer(state = initialState, action: any): CalendarState {
  switch (action.type) {
    case SET_CALENDAR_STATUS:
      return {
        ...state,
        status: { ...state.status, [action.payload.projectId]: action.payload.status },
      };
    case SET_CALENDAR_EVENTS:
      return {
        ...state,
        events: { ...state.events, [action.payload.projectId]: action.payload.events },
      };
    case SET_CALENDAR_LOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
}
